import { render, staticRenderFns } from "./IconDocumentReportSolid.vue?vue&type=template&id=4364c9fa"
import script from "./IconDocumentReportSolid.vue?vue&type=script&lang=js"
export * from "./IconDocumentReportSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports